import React from 'react'
import type { ValidationSummary } from '../../model/types'
import styles from './ImportFilterTabs.module.css'

export type ImportFilter = 'all' | 'valid' | 'unmatched' | 'error'

interface Props {
  active: ImportFilter
  summary: ValidationSummary
  onChange: (filter: ImportFilter) => void
}

const TABS: Array<{ key: ImportFilter; label: string }> = [
  { key: 'all', label: '전체' },
  { key: 'valid', label: '적용 가능' },
  { key: 'unmatched', label: '미매칭' },
  { key: 'error', label: '오류' },
]

/** Tab strip: All / Valid / Unmatched / Error with counts. */
export const ImportFilterTabs: React.FC<Props> = ({ active, summary, onChange }) => {
  const countFor = (key: ImportFilter): number => {
    switch (key) {
      case 'all': return summary.total
      case 'valid': return summary.valid
      case 'unmatched': return summary.unmatched
      case 'error': return summary.error
    }
  }

  return (
    <div className={styles.tabs} role="tablist">
      {TABS.map(tab => {
        const count = countFor(tab.key)
        const isActive = active === tab.key
        return (
          <button
            key={tab.key}
            className={`${styles.tab} ${isActive ? styles.active : ''}`}
            role="tab"
            aria-selected={isActive}
            onClick={() => onChange(tab.key)}
            type="button"
          >
            {tab.label}
            <span className={styles.count}>{count}</span>
          </button>
        )
      })}
    </div>
  )
}
